import type { SchemaNode } from "./schemaEntityGraph";

export const WINNING_PAGE_01_ROUTE = "/blog/top-10-integrated-marketing-communications-agencies-london-2026/";

/**
 * Completes only the existing IMC comparison. The shared graph reducer calls
 * this after deduplication; it must never create a second JSON-LD script.
 */
export function completeWinningPage01Graph(nodes: SchemaNode[], route?: string): SchemaNode[] {
  if (route !== WINNING_PAGE_01_ROUTE) return nodes;
  const graph: SchemaNode[] = structuredClone(nodes);
  const canonical = `https://integrated.social${WINNING_PAGE_01_ROUTE}`;
  const article = graph.find(node => node["@id"] === `${canonical}#article`);
  const breadcrumb = graph.find(node => node["@type"] === "BreadcrumbList");
  const faq = graph.find(node => node["@id"] === `${canonical}#faq`);
  if (!article || !breadcrumb) return graph;

  // Preserve existing visible-scope about/mentions and prices. This closure does
  // not assert verified fees, alphabetical ordering or audited agency quality.
  article["@type"] = "BlogPosting";
  delete article.speakable;
  delete article.wordCount; // The shared body counter does not include separately rendered FAQ answers.
  if (article.image && typeof article.image === "object" && !Array.isArray(article.image)) {
    article.image = { ...(article.image as SchemaNode), width: 2560, height: 1440 };
  }
  breadcrumb["@id"] = `${canonical}#breadcrumb`;
  article.mainEntityOfPage = { "@id": `${canonical}#webpage` };
  if (faq) faq.isPartOf = { "@id": `${canonical}#webpage` };
  const page: SchemaNode = {
    "@type": "WebPage", "@id": `${canonical}#webpage`, url: canonical,
    name: article.headline, description: article.description, inLanguage: article.inLanguage,
    datePublished: article.datePublished, dateModified: article.dateModified,
    isPartOf: { "@id": "https://integrated.social/#website" }, mainEntity: { "@id": article["@id"] },
    breadcrumb: { "@id": breadcrumb["@id"] }, primaryImageOfPage: article.image,
  };
  const index = graph.findIndex(node => node["@id"] === page["@id"]);
  if (index === -1) graph.push(page);
  else graph[index] = page;
  return graph;
}
